exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-center {\n  text-align: center;\n}\n\n.flex{\n    display: flex;\n}\n.justify-center{\n    justify-content: center;\n}\n.justify-end{\n    justify-content: end !important;\n}\n.items-center{\n    align-items: center;\n}\n.mb-5{\n    margin-bottom: 50px;\n}\n.mt-5{\n    margin-top: 50px !important;\n}\n.mr-2{\n    margin-right: 20px !important;\n}\n.flex-grow{\n    flex-grow: 1 !important;\n}\n.min-width-unset{\n    min-width: unset !important;\n}\n\n.guest-standby-list-page{\n    width: 70%;\n    margin: auto;\n}", ""]);

// exports
